export default __webpack_public_path__ + "static/white-d58c083a7190fa2ecc87451c978fa510.gif";